// extracted by mini-css-extract-plugin
module.exports = {"title":"ProjectTitle_title__37QR0","link":"ProjectTitle_link__3q-y6","isParent":"ProjectTitle_isParent__2_kwh","linkIsActive":"ProjectTitle_linkIsActive__lxxKt"};